import { ChangeDetectorRef, Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, BusinessService, LangService, UiModalService } from '@app/core/services';
import { ModalUrlComponent } from '@app/shared/modal/modal-url/modal-url.component';
import { Actions } from '@app/shared/model';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-reception',
  styleUrls: ['./reception.component.scss'],
  templateUrl: './reception.component.html',
})
export class ReceptionComponent {
  title: string;

  enterAction = {
    id: 'enter',
    name: $localize`Enter Event`,
    primaryAction: true,
  };

  joinAction = {
    id: 'join',
    name: $localize`Join Event`,
  };

  addCommunityAction = Actions.addCommunityAction;

  get isCompanyMember(): boolean {
    return this.authService.selectedCompany?.statusid !== 1;
  }

  get isCompanyAdmin(): boolean {
    return this.authService.isCompanyAdmin;
  }

  lang = (id: string) => this.langService.lang(id);

  constructor(
    public authService: AuthService,
    private business: BusinessService,
    private toastr: ToastrService,
    private cd: ChangeDetectorRef,
    private modalService: UiModalService,
    private router: Router,
    private langService: LangService,
  ) {
    this.title = this.authService.selectedCompany
      ? this.authService.selectedCompany.name
      : $localize`:@@reception:Reception`;
  }

  addCommunity() {
    this.router.navigate(['/sign-up-create-url']);
  }

  handleAction(action: any, company: any) {
    if (action.id === 'join') {
      this.business.updateCompanyInvitation(company, true).subscribe(() => {
        this.toastr.success($localize`You have successfully joined ${company.name}`);
        this.authService.companies.find((c) => c.id === company.id).statusid = 2;
        this.authService.companies.find((c) => c.id === company.id).memberStatus = 'pending';
        this.authService.selectedCompany.statusid = 2;
        this.authService.selectedCompany.memberStatus = 'pending';
        this.cd.detectChanges();
      });
    }

    if (action.id === 'enter') {
      this.business.navigateToCompany(company);
    }
  }

  shareEvent() {
    const inputs = {
      title: 'Share Event',
      url: window.location.origin,
    };
    this.modalService.init(ModalUrlComponent, inputs);
  }
}
